import get from 'lodash/get'
import find from 'lodash/find'
import map from 'lodash/map'
import PropTypes from 'prop-types'
import React, {Component} from 'react'
import {connect} from 'react-redux'

import ProductReview from './Reviews/ProductReview'
import ReviewImageModal from './Reviews/ReviewImageModal'
import FeaturedReviewsBelt from './FeaturedReviewsBelt'
import ReadAllReviewsButton from './ReadAllReviewsButton'
import Throbber from '../Throbber'

import * as reviews from '../../store/reviews'

import {clearReviews, featuredReviewsLoaded} from '../../actions/reviews'

// Temporary until we completely move away from yotpo's api
const getYotpoCustomTitleValue = (object, value) => get(find(object, {title: value}), 'value', null)
const formatReview = (review) => ({
  id: get(review, 'id'),
  score: get(review, 'score'),
  event: get(review, 'custom_fields[--2327].value'),
  title: get(review, 'title'),
  content: get(review, 'content'),
  dateSubmitted: get(review, 'created_at'),
  user: {
    displayName: get(review, 'user.display_name'),
    userId: get(review, 'user.user_id'),
  },
  ratings: {
    fit: {value: getYotpoCustomTitleValue(review.custom_fields, 'The Fit')},
    quality: {value: getYotpoCustomTitleValue(review.custom_fields, 'The Quality')},
    service: {value: getYotpoCustomTitleValue(review.custom_fields, 'The Service')},
  },
  images: {
    thumbUrl: get(review, 'images_data[0].thumb_url'),
    originalUrl: get(review, 'images_data[0].original_url'),
  },
})

class ProductFeaturedReviews extends Component {
  componentDidMount() {
    this.props.onMount()
  }

  componentWillUnmount() {
    this.props.onUnmount()
  }

  render() {
    const {featuredReviews, fetchError} = this.props

    if (fetchError) {
      return null
    }
    if (featuredReviews) {
      return (
        <section className="pdp-section featured-reviews" id="featuredProductReviews">
          <h2 className="featured-reviews-title">Featured Reviews</h2>
          <FeaturedReviewsBelt />
          {map(featuredReviews, (review) => (
            <ProductReview key={review.id} review={formatReview(review)} />
          ))}
          <ReadAllReviewsButton />
          <ReviewImageModal />
        </section>
      )
    }
    return <Throbber />
  }
}

ProductFeaturedReviews.propTypes = {
  onUnmount: PropTypes.func.isRequired,
  featuredReviews: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.bool]),
  onMount: PropTypes.func.isRequired,
  fetchError: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
}

const mapStateToProps = (state) => ({
  featuredReviews: reviews.featuredReviews(state),
  fetchError: reviews.fetchError(state),
})

const mapDispatchToProps = (dispatch) => ({
  onUnmount: () => dispatch(clearReviews()),
  onMount: () => dispatch(featuredReviewsLoaded()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductFeaturedReviews)
